/* PDP ギャラリーの smooth scroll 中だけ slider counter 表示を固定する */
(() => {
  const namespace = window.AuremeProductGallery || {};

  if (namespace.CounterLockController) {
    return;
  }

  const ScrollUtils = namespace.ScrollUtils;
  const hasScrollUtilsApi =
    Number.isFinite(ScrollUtils?.SCROLL_TOLERANCE) &&
    typeof ScrollUtils?.getSettledScrollLeftFrameCount === 'function';
  if (!hasScrollUtilsApi) {
    console.error('[aureme-product-gallery-counter-lock-controller] scroll utils are not loaded.');
    return;
  }

  /* 目標位置 ±tolerance で 2 frame 連続静止したら解除。到達しない場合も 1.2 秒で強制解除する */
  const AUREME_COUNTER_LOCK_STABLE_FRAMES = 2;
  const AUREME_COUNTER_LOCK_SAFETY_DELAY = 1200;

  /* slider 本体から timer / RAF 管理を分離し、counter 固定状態だけを扱う */
  class CounterLockController {
    constructor(gallery) {
      this.gallery = gallery;
      this.state = null;
      this.frame = null;
      this.safetyTimer = null;
    }

    isLocked() {
      return Boolean(this.state);
    }

    lock({ currentPage, totalPages = this.gallery.totalPages, targetLeft }) {
      const lockedPage = Number(currentPage);
      const lockedTotalPages = Number(totalPages);
      const lockedTargetLeft = Number(targetLeft);
      if (
        !Number.isFinite(lockedPage) ||
        !Number.isFinite(lockedTotalPages) ||
        !Number.isFinite(lockedTargetLeft)
      ) {
        return;
      }

      this.cancel();
      this.state = {
        currentPage: lockedPage,
        totalPages: lockedTotalPages,
        targetLeft: lockedTargetLeft,
        previousLeft: null,
        stableFrames: 0,
      };
      this.apply();
      this.scheduleCheck();
      this.safetyTimer = window.setTimeout(() => {
        this.release();
      }, AUREME_COUNTER_LOCK_SAFETY_DELAY);
    }

    apply() {
      if (!this.state) return;

      this.gallery.currentPage = this.state.currentPage;
      this.gallery.renderCounter(this.state.currentPage, this.state.totalPages);
    }

    scheduleCheck() {
      window.cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.checkScrollSettled();
      });
    }

    checkScrollSettled() {
      if (!this.state || !this.gallery.slider) return;

      const currentLeft = this.gallery.slider.scrollLeft;
      const tolerance = ScrollUtils.SCROLL_TOLERANCE;
      this.state.stableFrames = ScrollUtils.getSettledScrollLeftFrameCount({
        currentLeft,
        previousLeft: this.state.previousLeft,
        stableFrames: this.state.stableFrames,
        targetLeft: this.state.targetLeft,
        tolerance,
      });
      this.state.previousLeft = currentLeft;

      if (this.state.stableFrames >= AUREME_COUNTER_LOCK_STABLE_FRAMES) {
        this.release();
        return;
      }

      this.scheduleCheck();
    }

    release() {
      if (!this.state) return;

      this.cancel();
      this.gallery.update();
    }

    cancel() {
      this.state = null;
      window.cancelAnimationFrame(this.frame);
      this.frame = null;
      window.clearTimeout(this.safetyTimer);
      this.safetyTimer = null;
    }

    disconnect() {
      this.cancel();
    }
  }

  namespace.CounterLockController = CounterLockController;
  window.AuremeProductGallery = namespace;
})();
